import { CommonApiResponse, PlanCheckResponse, PlanCheckTrackerResponse } from "../../Controllers/Types/ApiResponse";
import apiClient from "../apiClient";
import { baseURL } from "../ApiConstant";

// get plan check list data.
export const getPlanCheckByFolderId = async (folder_id: number) => {
  try {
    const response = await apiClient.get(`/api/plan-check/list/${folder_id}`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// create plan check
export const createPlanCheck = async (
  folder_id: number,
  check_type: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/plan-check/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({
        folder_id,
        check_type,
      }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        data: data.data
      };
    } else if (response.status === 401) {
      return {
        status: false,
        statusCode: 401,
        massage: "Unauthorized"
      };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return {
        status: false,
        statusCode: 404,
        massage: "Not found"
      };
    } else {
      return {
        status: false,
        statusCode: 500,
        massage: "Error"
      };
    }
  } catch (error) {
    throw error;
  }
};

// PART
// create plan check part
export const createPlanCheckPart = async (
  folder_id: number,
  part_number: string,
  part_title: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/plan-check-part/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({
        folder_id,
        part_number,
        part_title,
      }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// update plan check part
export const updatePlanCheckPart = async (
  part_number: string,
  part_title: string,
  id: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/plan-check-part/update/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({
          part_number,
          part_title,
        }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//  delete functions
export const deletePlanCheckPart = async (
  id: number
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(
      `${baseURL}/api/plan-check-part/delete/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};
// ITEM

// create plan check Item
export const createPlanCheckItem = async (
  plan_check_id: number,
  check_type: string,
  folder_id: number,
  plan_check_part_id: number | null,
  item_code: string,
  comment: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/plan-check-item/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({
        plan_check_id,
        check_type,
        folder_id,
        plan_check_part_id,
        item_code,
        comment,
      }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// update plan check item
export const updatePlanCheckItem = async (
  plan_check_id: number,
  item_code: string,
  comment: string,
  status: string,
  id: number
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/plan-check-item/update/${id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({
          plan_check_id,
          item_code,
          comment,
          status,
        }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//  delete functions
export const deletePlanCheckItem = async (
  id: number
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(
      `${baseURL}/api/plan-check-item/delete/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// Responce by BI and Arch
export const responsePlanCheck = async (
  plan_check_id: number,
  plan_check_item_id: number,
  response: string,
  response_from: string,
  statusInput: string | null
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const status: string | null =
      statusInput === null
        ? null
        : statusInput === "Satisfactory"
          ? "Closed"
          : "Open";
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const responseData = await fetch(`${baseURL}/api/plan-check/response`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({
        plan_check_id,
        plan_check_item_id,
        response: response ? response : "N/A",
        response_from,
        status,
      }),
    });

    const data = await responseData.json();

    if (responseData.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (responseData.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (responseData.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (responseData.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//File Upload
export const uploadPlanCheckFiles = async (
  plan_check_id: number,
  plan_check_item_id: number,
  file_list: File[]
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    /* create form data */
    const formData = new FormData();
    formData.append("plan_check_id", String(plan_check_id));
    formData.append("plan_check_item_id", String(plan_check_item_id));

    if (file_list && file_list.length > 0) {
      file_list.forEach((file) => {
        formData.append("file_list[]", file); // Using "file_list[]" if backend expects array format
      });
    }

    const response = await fetch(`${baseURL}/api/plan-check/file-upload`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: formData,
    });
    const data = await response.json();
    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//  delete functions
export const deletePlanCheckFile = async (
  id: number
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(
      `${baseURL}/api/plan-check/file-delete/${id}`,
      {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

//  delete functions
export const removeSignPlanCheckReport = async (
  id: number
): Promise<CommonApiResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;

    const response = await fetch(`${baseURL}/api/plan-check/un-sign/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return { status: false, statusCode: 422, massage: "Body error" };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// create plan check Item
export const sharePlanCheck = async (
  plan_check_id: number,
  email: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/plan-check/email-send`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({
        plan_check_id,
        email,
      }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// publish by Bi
export const signAndPublishPlanCheckByBI = async (
  plan_check_id: number,
  is_published_by_bi: number,
  sign: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/plan-check/publish-by-building-inspector`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({
          plan_check_id,
          is_publish: is_published_by_bi,
          sign,
        }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// publish by Arc
export const signAndPublishPlanCheckByArc = async (
  plan_check_id: number,
  is_published_by_arc: number,
  sign: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/plan-check/publish-by-architecture`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({
          plan_check_id,
          is_publish: is_published_by_arc,
          sign,
        }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// create response document by architect
export const createPlanCheckResponseByArc = async (
  plan_check_id: number
): Promise<PlanCheckResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/plan-check-response-create-by-architecture`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({
          plan_check_id,
        }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        data: data["data"]
      };
    } else if (response.status === 401) {
      return {
        status: false,
        statusCode: 401,
        massage: "Unauthorized",
        data: null
      };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
        data: null
      };
    } else if (response.status === 404) {
      return {
        status: false,
        statusCode: 404,
        massage: "Not found",
        data: null
      };
    } else {
      return {
        status: false,
        statusCode: 500,
        massage: "Error",
        data: null
      };
    }
  } catch (error) {
    throw error;
  }
};

// create response document by bi
export const createPlanCheckResponseByBi = async (
  plan_check_id: number
): Promise<PlanCheckResponse> => {
  try {
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/plan-check-response-create-by-bi`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({
          plan_check_id,
        }),
      }
    );

    const data = await response.json();

    console.log('api response data', data)

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        data: data["data"]
      };
    } else if (response.status === 401) {
      return {
        status: false,
        statusCode: 401,
        massage: "Unauthorized",
        data: null
      };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
        data: null
      };
    } else if (response.status === 404) {
      return {
        status: false,
        statusCode: 404,
        massage: "Not found",
        data: null
      };
    } else {
      return {
        status: false,
        statusCode: 500,
        massage: "Error",
        data: null
      };
    }
  } catch (error) {
    throw error;
  }
};

// for plancheck trackers
///////////////////////////////// --------------------------------- /////////////////////////////////

// get plan check tracker list data.
export const getPlanCheckTrackerByFolderId = async (folder_id: number) => {
  try {
    const response = await apiClient.get(
      `/api/plan-check-tracker/list/${folder_id}`
    );
    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};

// create plan check tracker
export const createPlanCheckTracker = async (
  folder_id: number,
  check_type: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(`${baseURL}/api/plan-check-tracker/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: FULL_TOKEN,
      },
      body: JSON.stringify({
        folder_id,
        check_type,
      }),
    });

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        data: data.data
      };
    } else if (response.status === 401) {
      return {
        status: false,
        statusCode: 401,
        massage: "Unauthorized"
      };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return {
        status: false,
        statusCode: 404,
        massage: "Not found"
      };
    } else {
      return {
        status: false,
        statusCode: 500,
        massage: "Error"
      };
    }
  } catch (error) {
    throw error;
  }
};

// create response document by building inspector
export const createPlanCheckTrackerResponseByBi = async (
  plan_check_id: number
): Promise<PlanCheckTrackerResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/plan-check-tracker-response-create-by-bi`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({
          plan_check_id,
        }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        data: data["data"]
      };
    } else if (response.status === 401) {
      return {
        status: false,
        statusCode: 401,
        massage: "Unauthorized",
        data: null
      };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
        data: null
      };
    } else if (response.status === 404) {
      return {
        status: false,
        statusCode: 404,
        massage: "Not found",
        data: null
      };
    } else {
      return {
        status: false,
        statusCode: 500,
        massage: "Error",
        data: null
      };
    }
  } catch (error) {
    throw error;
  }
};

// create response document by architect
export const createPlanCheckTrackerResponseByArc = async (
  plan_check_id: number
): Promise<PlanCheckTrackerResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/plan-check-tracker-response-create-by-architecture`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({
          plan_check_id,
        }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return {
        status: true,
        statusCode: 200,
        data: data["data"]
      };
    } else if (response.status === 401) {
      return {
        status: false,
        statusCode: 401,
        massage: "Unauthorized",
        data: null
      };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
        data: null
      };
    } else if (response.status === 404) {
      return {
        status: false,
        statusCode: 404,
        massage: "Not found",
        data: null
      };
    } else {
      return {
        status: false,
        statusCode: 500,
        massage: "Error",
        data: null
      };
    }
  } catch (error) {
    throw error;
  }
};

// publish by Bi
export const signAndPublishPlanCheckTrackerByBI = async (
  plan_check_id: number,
  is_published_by_bi: number,
  sign: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/plan-check-tracker/publish-by-building-inspector`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({
          plan_check_id,
          is_publish: is_published_by_bi,
          sign,
        }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

// publish by Arc
export const signAndPublishPlanCheckTrackerByArc = async (
  plan_check_id: number,
  is_published_by_arc: number,
  sign: string
): Promise<CommonApiResponse> => {
  try {
    // prepare ids for number list
    const token = localStorage.getItem("token");
    const FULL_TOKEN = `Bearer ${token}`;
    const response = await fetch(
      `${baseURL}/api/plan-check-tracker/publish-by-architecture`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: FULL_TOKEN,
        },
        body: JSON.stringify({
          plan_check_id,
          is_publish: is_published_by_arc,
          sign,
        }),
      }
    );

    const data = await response.json();

    if (response.status === 200) {
      return { status: true, statusCode: 200 };
    } else if (response.status === 401) {
      return { status: false, statusCode: 401, massage: "Unauthorized" };
    } else if (response.status === 422) {
      return {
        status: false,
        statusCode: 422,
        errors: data["errors"],
        massage: "Body error",
      };
    } else if (response.status === 404) {
      return { status: false, statusCode: 404, massage: "Not found" };
    } else {
      return { status: false, statusCode: 500, massage: "Error" };
    }
  } catch (error) {
    throw error;
  }
};

/* Get plan check reference list */
export const getPlanCheckReference = async () => {
  try {
    const response = await apiClient.get(`/api/plan-check/list-reference`);

    if (response.status === 200) {
      return { status: true, body: response.data };
    } else {
      return { status: false, error: "failed" };
    }
  } catch (error: any) {
    // Handle error (display error message, log, etc.)
    return {
      status: false,
      error: "An error occurred. Please try again later.",
    };
  }
};